import { get, post } from '../axios'

// 登录
export function portal_login_sign_in_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/login/sign/in`,
    map,
    option
  ).then(response => response)
}

// 注销
export function portal_login_sign_out_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/login/sign/out`,
    map,
    option
  ).then(response => response)
}

// 密码登入
export function portal_login_sign_by_password_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/login/sign/by-password`,
    map,
    option
  ).then(response => response)
}

// 注册
export function portal_login_register_post(map, option) {
  return post(
    `${process.env.VUE_APP_PORTAL}/portal/login/register`,
    map,
    option
  ).then(response => response)
}

// 模拟登录确认
export function portal_login_simulate_confirm_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/login/simulate/confirm`,
    map,
    option
  ).then(response => response)
}

// 模拟登录取消
export function portal_login_simulate_cancel_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/login/simulate/cancel`,
    map,
    option
  ).then(response => response)
}
